import React from 'react';
import { TextVariant } from '@naf/text';
import CalendarImage from '../../../../../assets/images/CalendarImage.png';
import { NoHitWrapper, StyledCalendarImage, NoHitHeader, NoHitText } from './EventList.styles';
import { EmptyStateProps } from './EventList.types';

const EmptyState = ({ noHitText, button }: EmptyStateProps) => (
  <NoHitWrapper>
    <StyledCalendarImage src={CalendarImage} alt="Tom kalender" />
    <NoHitHeader variant={TextVariant.Header2}>Ingen arrangementer er lagt ut</NoHitHeader>
    <NoHitText variant={TextVariant.BodyText}>{noHitText}</NoHitText>
    {button}
  </NoHitWrapper>
);

export default EmptyState;
